import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import BasicDetails from './components/basic-details'
import IncomeDetails from './components/income-details'
import {setAccessToken, setOffersData, updateStep} from "../../core/store/actions";
import {compose} from "redux";
import {connect} from "react-redux";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import Radio from "@material-ui/core/Radio";
import TextField from "@material-ui/core/TextField";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import {Input} from "@material-ui/core";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import RupeeIcon from "./assets/rupee.svg"
import RupeeWhiteIcon from "./assets/rupee_white.png"
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import HistoryIcon from '@material-ui/icons/History';
import InputAdornment from "@material-ui/core/InputAdornment";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import {ArrowBack} from '@material-ui/icons';
import IconButton from "@material-ui/core/IconButton";

const styles = {
    root: {
        flexGrow: 1,
    },
    mainContainer:{
        paddingTop:"70px"
    },
    textDiv:{
        textAlign:"right",
        width:200,
        height:40,
    },
    outerCard:{
        width:"360px"
    },
    outerCardTax:{
        // width:"600px",
        marginTop:"20px",
        borderRadius:"10px"
    },
    innerCard:{
        marginTop:"20px",
        borderRadius:"10px"
    },
    innerPanel:{
        borderRadius:"10px !important"
    },
    head:{
        padding:"20px"
    },
    radioBtnBox:{
        marginTop: "15px",
    },
    radioGroup:{
        display:"flex",
        flexDirection:"row",
        justifyContent:"center"
    },
    cardContent:{
        padding:"20px"
    },
    radioGroupColumn:{
        display:"flex",
        flexDirection:"column",
        justifyContent:"center",
        paddingLeft:"24%"
    },
    radioGroupIncomeColumn:{
        width:200,
        flex:1,
    },
    nextBtn:{
        marginTop:"20px",
        borderRadius: "50px"
    },
    nextBtnIncome:{
        marginTop:"20px",
        marginBottom:"20px",
        borderRadius: "50px",
        textTransform:"capitalize"
    },
    expansionPadding:{
    },
    expansionSummary:{
        textAlign:"left"
    },
    expansionPaddingDetails:{
        paddingBottom:"5px !important",
        paddingTop:"5px !important"
    },
    flexDivPanel:{
        display:"flex",
        flex:1,
        justifyContent:"space-between"
    },
    flexDivTitle:{
      flex:1,
      textAlign:"left"
    },
    selectBoxDiv:{
      flex:1
    },
    select:{
        width:"160px"
    },
    flexDivField:{
      flex:1
    },
    rupeeIcon:{
        width:15
    },
    rupeeIconWhite:{
        width:15,
        color:"#fff"
    },
    listHead:{
        padding:"20px 0px",
        borderBottom:"1px solid #ccc"
    },
    listHeadItem:{
        borderRight:"1px solid #ccc"
    },
    tableGrid:{
      padding:"40px"
    },
    tableContainer:{
      border:"0.5px solid #ccc",
        borderRadius:"3px"
    },
    table:{

    },
    totalAmountRow:{
        // backgroundColor:"#455a64",
        color:"#fff"
    },
    backIcon:{
        // position:"absolute",
        // top:0,
        // left:50,
        backgroundColor:"#3f51b5 !important",
        color:"#fff !important",
        boxShadow:"2px 2px 6px 0px #ccc !important"
    },
    mainHeadDiv:{
        display:"flex",
        flexDirection:"row",
        alignItems:"center"
    }
};

class LegaxCalculator extends Component {

    constructor(props) {
        super(props);
        this.state = {
            financial_year:"2020-2021",
            current_age:"Below 60 years",
            annual_salary : 0,
            actual_rent:0,
            hra_received:0,
            city:"metro",
            other_allowances:0,
            self_occupied_hp_loss:0,
            saving_account_interest:0,
            fixed_deposite_interest:0,
            domestic_dividend:0,
            other_income:0,
            deduction_on_us:0,
            investments_in_nps:0,
            health_insurance_premium:0,
            for_health_insurance_premium:"self and family",
            medical_expenditure:0,
            for_medical_expenditure:"self(senior citizen) and family",
            preventive_health_checkup:0,
            for_preventive_health_checkup:"self and family",
            donation_to_charity:0,
            interest_on_education_loan:0,
            interest_on_savings_deposite:0,
            interest_paid_on_home_loan:0,
            gross_income:0,
            total_deduction:0,
            total_income:0,
            tax_payable:0,
            h_and_e_cess:0,
            surcharge:0,
            final_tax:0
        };
    }

    handleFinancialYearChange = (e)=>{
        this.setState({financial_year : e.target.value})
    }

    handleCurrentChange = (e)=>{
        this.setState({current_age : e.target.value})
    }
    handleAnnualSalary = (e)=>{
        this.setState({annual_salary : e.target.value})
    }
    handleActualRent = (e)=>{
        this.setState({actual_rent : e.target.value})
    }
    handleHraReceived = (e)=>{
        this.setState({hra_received : e.target.value})
    }
    handleCity = (e)=>{
        this.setState({city : e.target.value})
    }
    handleOtherAllowances = (e)=>{
        this.setState({other_allowances : e.target.value})
    }
    handleHPLoss = (e)=>{
        this.setState({self_occupied_hp_loss : e.target.value})
    }
    handleSavingAccountInterest = (e)=>{
        this.setState({saving_account_interest : e.target.value})
    }
    handleFixedDepositeInterest = (e)=>{
        this.setState({fixed_deposite_interest : e.target.value})
    }
    handleDomesticDividend = (e)=>{
        this.setState({domestic_dividend : e.target.value})
    }
    handleOtherIncome = (e)=>{
        this.setState({other_income : e.target.value})
    }
    handleDeductionOnUs = (e)=>{
        this.setState({deduction_on_us : e.target.value})
    }
    handleInvestmentsInUps = (e)=>{
        this.setState({investments_in_nps : e.target.value})
    }
    handleHealthInsurancePremium = (e)=>{
        this.setState({health_insurance_premium : e.target.value})
    }
    handleForHealthInsurancePremium = (e)=>{
        this.setState({for_health_insurance_premium : e.target.value})
    }
    handleMedicalExpenditure = (e)=>{
        this.setState({medical_expenditure : e.target.value})
    }
    handleForMedicalExpenditure = (e)=>{
        this.setState({for_medical_expenditure : e.target.value})
    }
    handlePreventHealthCheckup = (e)=>{
        this.setState({preventive_health_checkup : e.target.value})
    }
    handleForPreventHealthCheckup = (e)=>{
        this.setState({for_preventive_health_checkup : e.target.value})
    }
    handleDonationToCharity = (e)=>{
        this.setState({donation_to_charity : e.target.value})
    }
    handleInterestOnEducationLoan = (e)=>{
        this.setState({interest_on_education_loan : e.target.value})
    }
    handleInterestOnSavingDeposite = (e)=>{
        this.setState({saving_account_interest : e.target.value})
    }
    handleInterestPaidOnHomeLoan = (e)=>{
        this.setState({interest_paid_on_home_loan : e.target.value})
    }
    calculateHRA = ()=>{
        const {annual_salary, actual_rent,hra_received,city } = this.state

        let hra = 0
        let deducted_hra = 0
        // if(annual_salary > parseFloat(250000)){
            if(city == "metro"){
                // first condition
                let deducted_salary = (parseFloat(annual_salary) / 100)*50
                deducted_hra = parseFloat(hra_received)-parseFloat(deducted_salary)
            }else{
                let deducted_salary = (parseFloat(annual_salary) / 100)*40
                deducted_hra = parseFloat(hra_received)-parseFloat(deducted_salary)
            }
        // second condition
        let fina_received_hra = parseFloat(hra_received)-parseFloat(actual_rent)

        // third condition
        let ten_percent_salary = (parseFloat(annual_salary) / 100)*10
        let actual_paid = parseFloat(actual_rent)-parseFloat(ten_percent_salary)
        let final_hra_value = Math.min(deducted_hra , fina_received_hra , actual_paid)


        console.log(deducted_hra ,fina_received_hra , actual_paid )

        console.log(final_hra_value)
        if(final_hra_value < 0){
           return 0
        }

        if(isNaN(final_hra_value)){
                return 0
        }

         return final_hra_value

        // }else{
        //     return parseFloat(hra_received) - parseFloat(actual_rent)
        // }
    }

    calculateOtherIncomes  = ()=>{
        const {saving_account_interest, fixed_deposite_interest, domestic_dividend, other_income,} = this.state
        let final_value = parseFloat(saving_account_interest)+parseFloat(fixed_deposite_interest)
            +parseFloat(domestic_dividend)+parseFloat(other_income)
        if(final_value < 0 || isNaN(final_value)){
            return 0
        }
        return final_value
     }
    calculateInvestments  = ()=>{
        const {deduction_on_us, investments_in_nps} = this.state
        let final_value = parseFloat(deduction_on_us)+parseFloat(investments_in_nps)
        if(final_value < 0 || isNaN(final_value)){
            return 0
        }
        return final_value
     }
    calculateMedical  = ()=>{
        const {health_insurance_premium, medical_expenditure , preventive_health_checkup} = this.state
        let final_value = parseFloat(health_insurance_premium)+parseFloat(medical_expenditure)+parseFloat(preventive_health_checkup)
        if(final_value < 0 || isNaN(final_value)){
            return 0
        }
        return final_value
     }
    calculateOtherDeductions  = ()=>{
        const {interest_on_education_loan, saving_account_interest , interest_paid_on_home_loan} = this.state
        let final_value = parseFloat(interest_on_education_loan)+parseFloat(saving_account_interest)+parseFloat(interest_paid_on_home_loan)
        if(final_value < 0 || isNaN(final_value)){
            return 0
        }
        return final_value
     }

    calculateIncomeTax = ()=>{
        const {financial_year , current_age , annual_salary, actual_rent , hra_received, city,
            other_allowances, self_occupied_hp_loss, saving_account_interest, fixed_deposite_interest,
            domestic_dividend, other_income, deduction_on_us, investments_in_nps,health_insurance_premium,
            for_health_insurance_premium,medical_expenditure,for_medical_expenditure,preventive_health_checkup,
            for_preventive_health_checkup, donation_to_charity, interest_on_education_loan, interest_on_savings_deposite,
            interest_paid_on_home_loan,gross_income,total_deduction,total_income,tax_payable,h_and_e_cess,surcharge
        } = this.state;



        let HRA = this.calculateHRA()

        let income_from_salary = parseFloat(annual_salary)+parseFloat(HRA)+parseFloat(other_allowances)
            +parseFloat(saving_account_interest)+parseFloat(fixed_deposite_interest)+parseFloat(domestic_dividend)
            +parseFloat(other_income)

        let total_deduction_from_income = parseFloat(deduction_on_us)+parseFloat(investments_in_nps)
            +parseFloat(health_insurance_premium)+parseFloat(medical_expenditure)+parseFloat(preventive_health_checkup)
            +parseFloat(donation_to_charity)+parseFloat(interest_on_education_loan)+parseFloat(interest_on_savings_deposite)
            +parseFloat(interest_paid_on_home_loan)+parseFloat(self_occupied_hp_loss)

        if(total_deduction_from_income > 150000){
            total_deduction_from_income = 150000
            this.setState({total_deduction : total_deduction_from_income})
        }

        let taxable_income = parseFloat(income_from_salary)-parseFloat(total_deduction_from_income)
        this.setState({total_deduction : total_deduction_from_income , gross_income:income_from_salary,
            total_income:taxable_income})

        let tax = 0
        let surcharge_amount = 0
        let h_and_e_cess_amount = 0
        let deduct_taxable_income = parseFloat(taxable_income)-250000

        if(current_age == "Below 60 years"){

            if((taxable_income > 250000) && (taxable_income <= 500000) ){
                tax = (deduct_taxable_income / 100)*5
                h_and_e_cess_amount = (taxable_income / 100)*4
            }
            else if((taxable_income > 500000) && (taxable_income <= 1000000)){
                tax = (deduct_taxable_income / 100)*20
                h_and_e_cess_amount = (taxable_income / 100)*4
            }else if(taxable_income > 1000000){
                tax = (deduct_taxable_income / 100)*30
                h_and_e_cess_amount = (taxable_income / 100)*4
            }else{
                tax = 0
                h_and_e_cess_amount = 0
            }

        }else if(current_age == "60 to 80 years"){

            deduct_taxable_income = parseFloat(taxable_income)-300000

            if((taxable_income > 300000) && (taxable_income <= 500000) ){
                tax = (deduct_taxable_income / 100)*5
                h_and_e_cess_amount = (taxable_income / 100)*4
            }
            else if((taxable_income > 500000) && (taxable_income <= 1000000)){
                tax = (deduct_taxable_income / 100)*20
                h_and_e_cess_amount = (taxable_income / 100)*4
            }else if(taxable_income > 1000000){
                tax = (deduct_taxable_income / 100)*30
                h_and_e_cess_amount = (taxable_income / 100)*4
            }else{
                tax = 0
                h_and_e_cess_amount = 0
            }

        }else {
            deduct_taxable_income = parseFloat(taxable_income)-500000

            if((taxable_income > 500000) && (taxable_income <= 1000000)){
                tax = (deduct_taxable_income / 100)*20
                h_and_e_cess_amount = (taxable_income / 100)*4
            }else if(taxable_income > 1000000){
                tax = (deduct_taxable_income / 100)*30
                h_and_e_cess_amount = (taxable_income / 100)*4
            }else{
                tax = 0
                h_and_e_cess_amount = 0
            }
        }

        if(taxable_income > 5000000){
            surcharge_amount = (tax / 100)*10
            h_and_e_cess_amount = (surcharge_amount / 100)*4
        }else if(taxable_income > 10000000){
            surcharge_amount = (tax / 100)*15
            h_and_e_cess_amount = (surcharge_amount / 100)*4
        }


        let final_tax = tax+surcharge_amount+h_and_e_cess_amount

        this.setState({tax_payable : tax , surcharge:surcharge_amount
            , h_and_e_cess : h_and_e_cess_amount , final_tax})

    }

    onClickNext = ()=>{
        if(this.props.step == 1){
            this.props.updateStep(this.props.step+1)
        }else if(this.props.step == 2){
            this.calculateIncomeTax()
        }
        this.props.updateStep(this.props.step+1)

    }
    onClickBack = ()=>{
        if(this.props.step > 0) {
            this.props.updateStep(this.props.step - 1)
        }
    }


    render() {
        const {classes, step, updateStep} = this.props;
        const {financial_year , current_age , annual_salary, actual_rent , hra_received, city,
            other_allowances, self_occupied_hp_loss, saving_account_interest, fixed_deposite_interest,
            domestic_dividend, other_income, deduction_on_us, investments_in_nps,health_insurance_premium,
            for_health_insurance_premium,medical_expenditure,for_medical_expenditure,preventive_health_checkup,
            for_preventive_health_checkup, donation_to_charity, interest_on_education_loan, interest_on_savings_deposite,
            interest_paid_on_home_loan,gross_income,total_deduction,total_income,tax_payable,h_and_e_cess,surcharge
            ,final_tax
        } = this.state;

        const StyledTableRow = withStyles((theme) => ({
            root: {
                backgroundColor:"#455a64",
                color:"#fff"
            },
        }))(TableRow);
        const StyledTableCell = withStyles((theme) => ({
            body: {
                fontSize: 14,
                color: theme.palette.common.white,
            },
        }))(TableCell);
        const CustomizedTableCell = withStyles((theme) => ({
            head:{
                borderRight: "1px solid #ccc"
            },
            body: {
                borderBottom:"none",
                borderRight: "1px solid #ccc"
            },
        }))(TableCell);
        const LastTableCell = withStyles((theme) => ({
            head:{
                borderRight: "1px solid #ccc"
            },
            body: {
                borderBottom:"none",
            },
        }))(TableCell);

        const basicDetails = (<Grid container justify={"center"} className={classes.mainContainer}>
            <div className={classes.outerCard}>
                <Typography variant={'h4'} component={'h4'} style={{flex:1}}>
                    Basic Detalis
                </Typography>
                <Paper elevation={3} className={classes.innerCard}>
                    <div className={classes.head}>
                        <Typography variant={'body1'} >
                            Financial Year
                        </Typography>
                        <div className={classes.radioBtnBox}>
                            <RadioGroup value={financial_year} onChange={this.handleFinancialYearChange} className={classes.radioGroup}>
                                <FormControlLabel value={"2019-2020"} control={<Radio color={"primary"}/>} label={"2019-2020"}/>
                                <FormControlLabel value={"2020-2021"} control={<Radio color={"primary"}/>} label={"2020-2021"}/>
                            </RadioGroup>
                        </div>
                    </div>
                    <Divider/>
                    <div className={classes.cardContent}>
                        <Typography variant={'body1'} >
                            Your Current Age
                        </Typography>
                        <div className={classes.radioBtnBox}>
                            <RadioGroup value={current_age} onChange={this.handleCurrentChange} className={classes.radioGroupColumn}>
                                <FormControlLabel value={"Below 60 years"} control={<Radio color={"primary"}/>} label={"Below 60 years"}/>
                                <FormControlLabel value={"60 to 80 years"} control={<Radio color={"primary"}/>} label={"60 to 80 years"}/>
                                <FormControlLabel value={"80 years or above "} control={<Radio color={"primary"}/>} label={"80 years or above"}/>
                            </RadioGroup>
                        </div>
                        <Button variant="contained" color="primary" className={classes.nextBtn}
                                onClick={this.onClickNext}>
                            Next
                        </Button>
                    </div>
                </Paper>
            </div>
        </Grid>)
        const incomeDetails = ( <Grid container justify={"center"} className={classes.mainContainer}>
            <div className={classes.outerCard}>
                <div className={classes.mainHeadDiv}>
                    <IconButton color={"primary"} className={classes.backIcon} onClick={this.onClickBack}>
                        <ArrowBack/>
                    </IconButton>
                    <Typography variant={'h4'} component={'h4'} style={{flex:1}}>
                        Income Detalis
                    </Typography>
                    <IconButton color={"primary"} style={{display:"none"}}>
                        <ArrowBack/>
                    </IconButton>
                </div>

                <Paper elevation={3} className={classes.innerCard}>
                    <div className={classes.head}>
                        <Typography variant={'body1'} component={'body1'}>
                            Basic Salary
                        </Typography>
                        <div className={classes.radioBtnBox}>
                            {/*<Typography variant={'body1'} component={'body1'}>*/}
                            {/*    Enter Your Annual Salary*/}
                            {/*</Typography>*/}
                            <TextField
                                label="Enter Your Annual Salary"
                                variant="outlined"
                                onChange={this.handleAnnualSalary}
                                autoFocus={false}
                                value={annual_salary}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            &#8377;
                                        </InputAdornment>
                                    ),
                                    type:"number"
                                }}
                                size="small"
                            />
                            {/*<OutlinedInput id="outlined-basic" variant="outlined"*/}
                            {/*               onChange={this.handleAnnualSalary}*/}
                            {/*               className={classes.textDiv}/>*/}
                        </div>
                    </div>
                </Paper>
                <Paper elevation={3} className={classes.innerCard}>
                    <ExpansionPanel className={classes.innerPanel}>
                        <ExpansionPanelSummary
                            className={classes.expansionPadding}
                            expandIcon={<ExpandMoreIcon/>}
                            aria-controls="panel1a-content"
                            id="panel1a-header">
                            <Grid direction={"column"} className={classes.expansionSummary}>
                                <Typography variant={"h6"}>HRA</Typography>
                                <Typography variant={"body1"}> &#8377; {this.calculateHRA()}</Typography>
                            </Grid>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails
                            className={classes.expansionPaddingDetails}>
                            <div className={classes.flexDivPanel}>
                                <Typography variant={"subtitle1"} className={classes.flexDivTitle}>Actual Rent</Typography>
                                <TextField
                                    variant="outlined"
                                    onChange={this.handleActualRent}
                                    autoFocus={false}
                                    value={actual_rent}
                                    className={classes.flexDivField}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                &#8377;
                                            </InputAdornment>
                                        ),
                                        type:"number"
                                    }}
                                    size="small"
                                />
                            </div>
                        </ExpansionPanelDetails>
                        <ExpansionPanelDetails
                            className={classes.expansionPaddingDetails}>
                            <div className={classes.flexDivPanel}>
                                <Typography variant={"subtitle1"} className={classes.flexDivTitle}>HRA Received</Typography>
                                <TextField
                                    variant="outlined"
                                    onChange={this.handleHraReceived}
                                    autoFocus={false}
                                    value={hra_received}
                                    className={classes.flexDivField}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                &#8377;
                                            </InputAdornment>
                                        ),
                                        type:"number"
                                    }}
                                    size="small"
                                />
                            </div>
                        </ExpansionPanelDetails>
                        <ExpansionPanelDetails
                            className={classes.expansionPaddingDetails}>
                            <div className={classes.flexDivPanel}>
                                <Typography variant={"subtitle1"} className={classes.flexDivTitle}>City</Typography>
                                    <RadioGroup value={city} onChange={this.handleCity}
                                                className={classes.radioGroupIncomeColumn}>
                                        <FormControlLabel value={"metro"} control={<Radio color={"primary"}/>} label={"Metro (Delhi, Mumbai, Kolkata or Chennai)"}/>
                                        <FormControlLabel value={"non metro"} control={<Radio color={"primary"}/>} label={"Non Metro"}/>
                                    </RadioGroup>
                            </div>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </Paper>
                <Paper elevation={3} className={classes.innerCard}>
                    <ExpansionPanel className={classes.innerPanel}>
                        <ExpansionPanelSummary
                            className={classes.expansionPadding}
                            expandIcon={<ExpandMoreIcon/>}
                            aria-controls="panel1a-content"
                            id="panel1a-header">
                            <Grid direction={"column"} className={classes.expansionSummary}>
                                <Typography variant={"h6"}>Other Allowances</Typography>
                                <Typography variant={"body1"}> &#8377; {(isNaN(other_allowances) || other_allowances < 0) ? 0 : other_allowances}</Typography>
                            </Grid>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails
                            className={classes.expansionPaddingDetails}>
                            <div className={classes.flexDivPanel}>
                                <TextField
                                    variant="outlined"
                                    onChange={this.handleOtherAllowances}
                                    autoFocus={false}
                                    value={other_allowances}
                                    className={classes.flexDivField}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                &#8377;
                                            </InputAdornment>
                                        ),
                                        type:"number"
                                    }}
                                    size="small"
                                />
                            </div>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </Paper>
                <Paper elevation={3} className={classes.innerCard}>
                    <ExpansionPanel className={classes.innerPanel}>
                        <ExpansionPanelSummary
                            className={classes.expansionPadding}
                            expandIcon={<ExpandMoreIcon/>}
                            aria-controls="panel1a-content"
                            id="panel1a-header">
                            <Grid direction={"column"} className={classes.expansionSummary}>
                                <Typography variant={"h6"}>Self Occupied HP Loss</Typography>
                                <Typography variant={"body1"}> &#8377; {(isNaN(self_occupied_hp_loss) || self_occupied_hp_loss < 0) ? 0 : self_occupied_hp_loss}</Typography>
                            </Grid>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails
                            className={classes.expansionPaddingDetails}>
                            <div className={classes.flexDivPanel}>
                                <TextField
                                    variant="outlined"
                                    onChange={this.handleHPLoss}
                                    autoFocus={false}
                                    value={self_occupied_hp_loss}
                                    className={classes.flexDivField}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                &#8377;
                                            </InputAdornment>
                                        ),
                                        type:"number"
                                    }}
                                    size="small"
                                />
                            </div>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </Paper>
                <Paper elevation={3} className={classes.innerCard}>
                    <ExpansionPanel className={classes.innerPanel}>
                        <ExpansionPanelSummary
                            className={classes.expansionPadding}
                            expandIcon={<ExpandMoreIcon/>}
                            aria-controls="panel1a-content"
                            id="panel1a-header">
                            <Grid direction={"column"} className={classes.expansionSummary}>
                                <Typography variant={"h6"}>Other Incomes</Typography>
                                <Typography variant={"body1"}> &#8377; {this.calculateOtherIncomes()}</Typography>
                            </Grid>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails
                            className={classes.expansionPaddingDetails}>
                            <div className={classes.flexDivPanel}>
                                <Typography variant={"subtitle1"} className={classes.flexDivTitle}>Savings Account Interest</Typography>
                                <TextField
                                    variant="outlined"
                                    onChange={this.handleSavingAccountInterest}
                                    autoFocus={false}
                                    value={saving_account_interest}
                                    className={classes.flexDivField}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                &#8377;
                                            </InputAdornment>
                                        ),
                                        type:"number"
                                    }}
                                    size="small"
                                />
                            </div>
                        </ExpansionPanelDetails>
                        <ExpansionPanelDetails
                            className={classes.expansionPaddingDetails}>
                            <div className={classes.flexDivPanel}>
                                <Typography variant={"subtitle1"} className={classes.flexDivTitle}>Fixed Deposite Interest</Typography>
                                <TextField
                                    variant="outlined"
                                    onChange={this.handleFixedDepositeInterest}
                                    autoFocus={false}
                                    value={fixed_deposite_interest}
                                    className={classes.flexDivField}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                &#8377;
                                            </InputAdornment>
                                        ),
                                        type:"number"
                                    }}
                                    size="small"
                                />
                            </div>
                        </ExpansionPanelDetails>
                        <ExpansionPanelDetails
                            className={classes.expansionPaddingDetails}>
                            <div className={classes.flexDivPanel}>
                                <Typography variant={"subtitle1"} className={classes.flexDivTitle} >Domestic Dividend</Typography>
                                <TextField
                                    variant="outlined"
                                    onChange={this.handleDomesticDividend}
                                    autoFocus={false}
                                    value={domestic_dividend}
                                    className={classes.flexDivField}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                &#8377;
                                            </InputAdornment>
                                        ),
                                        type:"number"
                                    }}
                                    size="small"
                                />
                            </div>
                        </ExpansionPanelDetails>
                        <ExpansionPanelDetails
                            className={classes.expansionPaddingDetails}>
                            <div className={classes.flexDivPanel}>
                                <Typography variant={"subtitle1"} className={classes.flexDivTitle} >Other Income</Typography>
                                <TextField
                                    variant="outlined"
                                    onChange={this.handleOtherIncome}
                                    autoFocus={false}
                                    value={other_income}
                                    className={classes.flexDivField}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                &#8377;
                                            </InputAdornment>
                                        ),
                                        type:"number"
                                    }}
                                    size="small"
                                />
                            </div>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </Paper>

                <Button variant="contained" color="primary" className={classes.nextBtnIncome}
                        onClick={this.onClickNext}>
                    Next
                </Button>
            </div>
        </Grid>)
        const Dedcutions= ( <Grid container justify={"center"} className={classes.mainContainer}>
            <div className={classes.outerCard}>
                <div className={classes.mainHeadDiv}>
                    <IconButton color={"primary"} className={classes.backIcon} onClick={this.onClickBack}>
                        <ArrowBack/>
                    </IconButton>
                    <Typography variant={'h4'} component={'h4'} style={{flex:1}}>
                        Deductions
                    </Typography>
                    <IconButton color={"primary"} style={{display:"none"}}>
                        <ArrowBack/>
                    </IconButton>
                </div>

                <Paper elevation={3} className={classes.innerCard}>
                    <ExpansionPanel className={classes.innerPanel}>
                        <ExpansionPanelSummary
                            className={classes.expansionPadding}
                            expandIcon={<ExpandMoreIcon/>}
                            aria-controls="panel1a-content"
                            id="panel1a-header">
                            <Grid direction={"column"} className={classes.expansionSummary}>
                                <Typography variant={"h6"}>Investments</Typography>
                                <Typography variant={"body1"}> &#8377; {this.calculateInvestments()}</Typography>
                            </Grid>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails
                            className={classes.expansionPaddingDetails}>
                            <div className={classes.flexDivPanel}>
                                <Typography variant={"subtitle1"} className={classes.flexDivTitle} >Deductions u/s 80c</Typography>
                                <TextField
                                    variant="outlined"
                                    onChange={this.handleDeductionOnUs}
                                    autoFocus={false}
                                    value={deduction_on_us}
                                    className={classes.flexDivField}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                &#8377;
                                            </InputAdornment>
                                        ),
                                        type:"number"
                                    }}
                                    size="small"
                                />
                            </div>
                        </ExpansionPanelDetails>
                        <ExpansionPanelDetails
                            className={classes.expansionPaddingDetails}>
                            <div className={classes.flexDivPanel}>
                                <Typography variant={"subtitle1"}  className={classes.flexDivTitle} >Investments in NPS u/s 80CCD</Typography>
                                <TextField
                                    variant="outlined"
                                    onChange={this.handleInvestmentsInUps}
                                    autoFocus={false}
                                    value={investments_in_nps}
                                    className={classes.flexDivField}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                &#8377;
                                            </InputAdornment>
                                        ),
                                        type:"number"
                                    }}
                                    size="small"
                                />
                            </div>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </Paper>
                <Paper elevation={3} className={classes.innerCard}>
                    <ExpansionPanel className={classes.innerPanel}>
                        <ExpansionPanelSummary
                            className={classes.expansionPadding}
                            expandIcon={<ExpandMoreIcon/>}
                            aria-controls="panel1a-content"
                            id="panel1a-header">
                            <Grid direction={"column"} className={classes.expansionSummary}>
                                <Typography variant={"h6"}>Medical</Typography>
                                <Typography variant={"body1"}> &#8377; {this.calculateMedical()}</Typography>
                            </Grid>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails
                            className={classes.expansionPaddingDetails}>
                            <div className={classes.flexDivPanel}>
                                <Typography variant={"subtitle1"} className={classes.flexDivTitle} >Health Insurance Premium u/s 80D</Typography>
                                <div className={classes.selectBoxDiv}>
                                    <FormControl size={"small"} variant="outlined" className={classes.formControl}>
                                        <Select
                                            className={classes.select}
                                            labelId="demo-simple-select-outlined-label"
                                            id="demo-simple-select-outlined"
                                            value={for_health_insurance_premium}
                                            onChange={this.handleForHealthInsurancePremium}
                                        >
                                            <MenuItem value={"self and family"}>Self and Family</MenuItem>
                                            <MenuItem value={"self(senior citizen) and family"}>Self (Senior Citizen) and Family</MenuItem>
                                            <MenuItem value={"parents"}>Parents</MenuItem>
                                            <MenuItem value={"parents (senior citizen)"}>Parents (Senior Citizen)</MenuItem>
                                            <MenuItem value={"self and family including parents"}>Self and Family including Parents</MenuItem>
                                            <MenuItem value={"self and family including senior senior citizen parents"}>Self and Family including Senior Citizen Parents</MenuItem>
                                            <MenuItem value={"self(senior citizen) and family including senior citizen parents"}>Self (Senior Citizen) and Family including Senior Citizen Parents</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <br/><br/>
                                    <TextField
                                        variant="outlined"
                                        onChange={this.handleHealthInsurancePremium}
                                        autoFocus={false}
                                        value={health_insurance_premium}
                                        className={classes.flexDivField}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    &#8377;
                                                </InputAdornment>
                                            ),
                                            type:"number"
                                        }}
                                        size="small"
                                    />
                                </div>
                            </div>
                        </ExpansionPanelDetails>
                        <ExpansionPanelDetails
                            className={classes.expansionPaddingDetails}>
                            <div className={classes.flexDivPanel}>
                                <Typography variant={"subtitle1"} className={classes.flexDivTitle} >Medical Expenditure u/s 80D</Typography>
                                <div className={classes.selectBoxDiv}>
                                    <FormControl size={"small"} variant="outlined" className={classes.formControl}>
                                        <Select
                                            className={classes.select}
                                            labelId="demo-simple-select-outlined-label"
                                            id="demo-simple-select-outlined"
                                            value={for_medical_expenditure}
                                            onChange={this.handleForMedicalExpenditure}
                                            labelWidth={200}
                                        >
                                            <MenuItem value={"self(senior citizen) and family"}>Self (Senior Citizen) and Family</MenuItem>
                                            <MenuItem value={"parents (senior citizen)"}>Parents (Senior Citizen)</MenuItem>
                                            <MenuItem value={"self(senior citizen) and family including senior citizen parents"}>Self (Senior Citizen) and Family including Senior Citizen Parents</MenuItem>
                                        </Select>
                                    </FormControl>
                                                   <br/><br/>
                                    <TextField
                                        variant="outlined"
                                        onChange={this.handleMedicalExpenditure}
                                        autoFocus={false}
                                        value={medical_expenditure}
                                        className={classes.flexDivField}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    &#8377;
                                                </InputAdornment>
                                            ),
                                            type:"number"
                                        }}
                                        size="small"
                                    />
                                </div>
                            </div>
                        </ExpansionPanelDetails>
                        <ExpansionPanelDetails
                            className={classes.expansionPaddingDetails}>
                            <div className={classes.flexDivPanel}>
                                <Typography variant={"subtitle1"} className={classes.flexDivTitle} >Preventive Health Checkup u/s 80D</Typography>
                                <div className={classes.selectBoxDiv}>
                                    <FormControl size={"small"} variant="outlined" className={classes.formControl}>
                                        <Select
                                            className={classes.select}
                                            labelId="demo-simple-select-outlined-label"
                                            id="demo-simple-select-outlined"
                                            value={for_preventive_health_checkup}
                                            onChange={this.handleForPreventHealthCheckup}
                                        >
                                            <MenuItem value={"self and family"}>Self and Family</MenuItem>
                                            <MenuItem value={"parents"}>Parents</MenuItem>
                                            <MenuItem value={"self and family including parents"}>Self and Family including Parents</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <br/><br/>
                                    <TextField
                                        variant="outlined"
                                        onChange={this.handlePreventHealthCheckup}
                                        autoFocus={false}
                                        value={preventive_health_checkup}
                                        className={classes.flexDivField}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    &#8377;
                                                </InputAdornment>
                                            ),
                                            type:"number"
                                        }}
                                        size="small"
                                    />
                                </div>
                            </div>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </Paper>
                <Paper elevation={3} className={classes.innerCard}>
                    <ExpansionPanel className={classes.innerPanel}>
                        <ExpansionPanelSummary
                            className={classes.expansionPadding}
                            expandIcon={<ExpandMoreIcon/>}
                            aria-controls="panel1a-content"
                            id="panel1a-header">
                            <Grid direction={"column"} className={classes.expansionSummary}>
                                <Typography variant={"h6"}>Charity</Typography>
                                <Typography variant={"body1"}> &#8377; {(isNaN(donation_to_charity) || donation_to_charity < 0) ? 0 : donation_to_charity}</Typography>
                            </Grid>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails
                            className={classes.expansionPaddingDetails}>
                            <div className={classes.flexDivPanel}>
                                <Typography variant={"subtitle1"} className={classes.flexDivTitle}>Donation to charity u/s 80G</Typography>
                                <TextField
                                    variant="outlined"
                                    onChange={this.handleDonationToCharity}
                                    autoFocus={false}
                                    value={donation_to_charity}
                                    className={classes.flexDivField}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                &#8377;
                                            </InputAdornment>
                                        ),
                                        type:"number"
                                    }}
                                    size="small"
                                />
                            </div>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </Paper>
                <Paper elevation={3} className={classes.innerCard}>
                    <ExpansionPanel className={classes.innerPanel}>
                        <ExpansionPanelSummary
                            className={classes.expansionPadding}
                            expandIcon={<ExpandMoreIcon/>}
                            aria-controls="panel1a-content"
                            id="panel1a-header">
                            <Grid direction={"column"} className={classes.expansionSummary}>
                                <Typography variant={"h6"}>Other Deductions</Typography>
                                <Typography variant={"body1"}> &#8377; {this.calculateOtherDeductions()}</Typography>
                            </Grid>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails
                            className={classes.expansionPaddingDetails}>
                            <div className={classes.flexDivPanel}>
                                <Typography variant={"subtitle1"} className={classes.flexDivTitle} >Interest on Education Loan u/s 80E</Typography>
                                <TextField
                                    variant="outlined"
                                    onChange={this.handleInterestOnEducationLoan}
                                    autoFocus={false}
                                    value={interest_on_education_loan}
                                    className={classes.flexDivField}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                &#8377;
                                            </InputAdornment>
                                        ),
                                        type:"number"
                                    }}
                                    size="small"
                                />
                            </div>
                        </ExpansionPanelDetails>
                        <ExpansionPanelDetails
                            className={classes.expansionPaddingDetails}>
                            <div className={classes.flexDivPanel}>
                                <Typography variant={"subtitle1"} className={classes.flexDivTitle} >Interest on Saving Deposits u/s 80TTA</Typography>
                                <TextField
                                    variant="outlined"
                                    onChange={this.handleInterestOnSavingDeposite}
                                    autoFocus={false}
                                    value={saving_account_interest}
                                    className={classes.flexDivField}
                                    disabled={parseFloat(saving_account_interest) > 0 ? true : false}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                &#8377;
                                            </InputAdornment>
                                        ),
                                        type:"number"
                                    }}
                                    size="small"
                                />
                            </div>
                        </ExpansionPanelDetails>
                        <ExpansionPanelDetails
                            className={classes.expansionPaddingDetails}>
                            <div className={classes.flexDivPanel}>
                                <Typography variant={"subtitle1"} className={classes.flexDivTitle} >Interest paid on home Loan u/s 80EEA</Typography>
                                <TextField
                                    variant="outlined"
                                    onChange={this.handleInterestPaidOnHomeLoan}
                                    autoFocus={false}
                                    value={interest_paid_on_home_loan}
                                    className={classes.flexDivField}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                &#8377;
                                            </InputAdornment>
                                        ),
                                        type:"number"
                                    }}
                                    size="small"
                                />
                            </div>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </Paper>
                <Button variant="contained" color="primary" className={classes.nextBtnIncome}
                        onClick={this.onClickNext}
                >
                    Next
                </Button>
            </div>

        </Grid>)
        const Report= ( <Grid container justify={"center"} className={classes.mainContainer}>
            <div className={classes.outerCardTax}>
                <div className={classes.mainHeadDiv}>
                    <IconButton color={"primary"} className={classes.backIcon} onClick={this.onClickBack}>
                        <ArrowBack/>
                    </IconButton>
                    <Typography variant={'h4'} component={'h4'} style={{flex:1}}>
                        Your tax liability
                    </Typography>
                    <IconButton color={"primary"} style={{display:"none"}}>
                        <ArrowBack/>
                    </IconButton>
                </div>

                <Paper elevation={3} className={classes.outerCardTax}>
                    <Grid container className={classes.listHead}>
                        <Grid item xs={4} className={classes.listHeadItem}>
                            <Grid container alignItems={"center"} direction={"column"}>
                                <Typography variant={'subtitle1'} component={'subtitle1'}>
                                    &#8377; {gross_income}
                                </Typography>
                                <Typography variant={'subtitle1'} component={'subtitle1'}>
                                    Gross Total Income
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid item xs={4} className={classes.listHeadItem}>
                            <Grid container alignItems={"center"} direction={"column"}>
                                <Typography variant={'subtitle1'} component={'subtitle1'}>
                                    &#8377; {total_deduction}
                                </Typography>
                                <Typography variant={'subtitle1'} component={'subtitle1'}>
                                    Deductions
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid item xs={4}>
                            <Grid container alignItems={"center"} direction={"column"}>
                                <Typography variant={'subtitle1'} component={'subtitle1'}>
                                    &#8377; {tax_payable}
                                </Typography>
                                <Typography variant={'subtitle1'} component={'subtitle1'}>
                                    Tax
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container className={classes.tableGrid} >
                        <TableContainer className={classes.tableContainer}>
                            <Table size={"small"} className={classes.table}>
                                <TableHead>
                                    <TableRow>
                                        <CustomizedTableCell>Particulars</CustomizedTableCell>
                                        <CustomizedTableCell align="right">Old Tax Regime</CustomizedTableCell>
                                        <TableCell align="right">New Tax Regime</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                        <TableRow >
                                            <CustomizedTableCell component="th" scope="row">
                                                Gross Total Income
                                            </CustomizedTableCell>
                                            <CustomizedTableCell align="right">
                                                <Typography variant={'subtitle1'} component={'subtitle1'}>
                                                    &#8377; {gross_income}
                                                </Typography>
                                            </CustomizedTableCell>
                                            <LastTableCell align="right">
                                                <Typography variant={'subtitle1'} component={'subtitle1'}>
                                                    &#8377; 0
                                                </Typography>
                                            </LastTableCell>
                                        </TableRow>
                                    <TableRow >
                                        <CustomizedTableCell component="th" scope="row">
                                            Total Deductions
                                        </CustomizedTableCell>
                                        <CustomizedTableCell align="right">
                                            <Typography variant={'subtitle1'} component={'subtitle1'}>
                                                &#8377; {total_deduction}
                                            </Typography>
                                        </CustomizedTableCell>
                                        <LastTableCell align="right">
                                            <Typography variant={'subtitle1'} component={'subtitle1'}>
                                                &#8377; 0
                                            </Typography>
                                        </LastTableCell>
                                    </TableRow>
                                    <TableRow >
                                        <CustomizedTableCell component="th" scope="row">
                                            Total Income
                                        </CustomizedTableCell>
                                        <CustomizedTableCell align="right">
                                            <Typography variant={'subtitle1'} component={'subtitle1'}>
                                                &#8377; {total_income}
                                            </Typography>
                                        </CustomizedTableCell>
                                        <LastTableCell align="right">
                                            <Typography variant={'subtitle1'} component={'subtitle1'}>
                                                &#8377; 0
                                            </Typography>
                                        </LastTableCell>
                                    </TableRow>
                                    <TableRow >
                                        <CustomizedTableCell component="th" scope="row">
                                            Tax On Total Income
                                        </CustomizedTableCell>
                                        <CustomizedTableCell align="right">
                                            <Typography variant={'subtitle1'} component={'subtitle1'}>
                                                &#8377; {tax_payable}
                                            </Typography>
                                        </CustomizedTableCell>
                                        <LastTableCell align="right">
                                            <Typography variant={'subtitle1'} component={'subtitle1'}>
                                                &#8377; 0
                                            </Typography>
                                        </LastTableCell>
                                    </TableRow>
                                    <TableRow >
                                        <CustomizedTableCell component="th" scope="row">
                                            Surcharge
                                        </CustomizedTableCell>
                                        <CustomizedTableCell align="right">
                                            <Typography variant={'subtitle1'} component={'subtitle1'}>
                                                &#8377; {surcharge}
                                            </Typography>
                                        </CustomizedTableCell>
                                        <LastTableCell align="right">
                                            <Typography variant={'subtitle1'} component={'subtitle1'}>
                                                &#8377; 0
                                            </Typography>
                                        </LastTableCell>
                                    </TableRow>
                                    <TableRow >
                                        <CustomizedTableCell component="th" scope="row">
                                            Health & Education Cess
                                        </CustomizedTableCell>
                                        <CustomizedTableCell align="right">
                                            <Typography variant={'subtitle1'} component={'subtitle1'}>
                                                &#8377; {h_and_e_cess}
                                            </Typography>
                                        </CustomizedTableCell>
                                        <LastTableCell align="right">
                                            <Typography variant={'subtitle1'} component={'subtitle1'}>
                                                &#8377; 0
                                            </Typography>
                                        </LastTableCell>
                                    </TableRow>
                                    <StyledTableRow className={classes.totalAmountRow}>
                                        <StyledTableCell component="th" scope="row">
                                            Total Tax Payable
                                        </StyledTableCell>
                                        <StyledTableCell align="right">
                                            <Typography variant={'subtitle1'} component={'subtitle1'}>
                                                &#8377; {final_tax}
                                            </Typography>
                                        </StyledTableCell>
                                        <StyledTableCell align="right">
                                            <Typography variant={'subtitle1'} component={'subtitle1'}>
                                                &#8377; 0
                                            </Typography>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Paper>
                <Button color="primary" className={classes.nextBtnIncome}
                        onClick={()=>this.props.updateStep(0)} endIcon={<HistoryIcon/>}>
                    Calculate Again
                </Button>
            </div>
        </Grid>)

        let cartSteps = [basicDetails , incomeDetails, Dedcutions, Report]

        return (<div>{cartSteps[step]}</div>)
    }
}

const mapStateToProps = (state) => ({
    access_token: state.globals.access_token,
    offers_data: state.globals.offers_data,
    step: state.globals.step
})

const mapDispatchToProps = {
    setAccessToken, setOffersData, updateStep
}


export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(LegaxCalculator);
;
